import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import { each } from '@antv/util';
import { vec2 } from '@antv/matrix-util';
export default function (G6) {
  var mix = G6.Util.mix;
  G6.registerBehavior('itemAlign', {
    getDefaultCfg: function getDefaultCfg() {
      return {
        alignLineStyle: {
          stroke: '#FA8C16',
          lineWidth: 1
        },
        tolerance: 5,
        _alignLines: []
      };
    },
    getEvents: function getEvents() {
      return {
        'afternodedrag': 'onDrag',
        'afternodedragend': 'onDragEnd'
      };
    },
    onDrag: function onDrag(shape) {
      this._clearAlignLine();
      this._itemAlign(shape);
    },
    onDragEnd: function onDragEnd() {
      this._clearAlignLine();
    },
    _itemAlign: function _itemAlign(item) {
      var _this = this;
      var bbox = item.getBBox();
      var ct = {
        x: bbox.x + bbox.width / 2,
        y: bbox.y
      };
      var cc = {
        x: bbox.x + bbox.width / 2,
        y: bbox.y + bbox.height / 2
      };
      var cb = {
        x: bbox.x + bbox.width / 2,
        y: bbox.y + bbox.height
      };
      var lc = {
        x: bbox.x,
        y: bbox.y + bbox.height / 2
      };
      var rc = {
        x: bbox.x + bbox.width,
        y: bbox.y + bbox.height / 2
      };
      var nodes = this.graph.getNodes();
      each(nodes, function (node) {
        var horizontalLines = [];
        var verticalLines = [];
        var p = null;
        var bbox1 = node.getBBox();
        each(_this.getHorizontalLines(bbox1), function (line) {
          horizontalLines.push(_this.getDistance(line, ct));
          horizontalLines.push(_this.getDistance(line, cc));
          horizontalLines.push(_this.getDistance(line, cb));
        });
        each(_this.getVerticalLines(bbox1), function (line) {
          verticalLines.push(_this.getDistance(line, lc));
          verticalLines.push(_this.getDistance(line, cc));
          verticalLines.push(_this.getDistance(line, rc));
        });
        horizontalLines.sort(function (a, b) {
          return a.dis - b.dis;
        });
        verticalLines.sort(function (a, b) {
          return a.dis - b.dis;
        });
        if (horizontalLines.length > 0 && horizontalLines[0].dis < _this.tolerance) {
          item.attr({
            y: horizontalLines[0].line[1] - horizontalLines[0].point.y + bbox.y
          });
          p = {
            horizontals: [horizontalLines[0]]
          };
          for (var i = 1; i < 3; i++) horizontalLines[0].dis === horizontalLines[i].dis && p.horizontals.push(horizontalLines[i]);
        }
        if (verticalLines.length > 0 && verticalLines[0].dis < _this.tolerance) {
          item.attr({
            x: verticalLines[0].line[0] - verticalLines[0].point.x + bbox.x
          });
          p ? p.verticals = [verticalLines[0]] : p = {
            verticals: [verticalLines[0]]
          };
          for (var _i = 1; _i < 3; _i++) verticalLines[0].dis === verticalLines[_i].dis && p.verticals.push(verticalLines[_i]);
        }
        if (p) {
          p.bbox = bbox;
          _this._addAlignLine(p);
        }
      });
    },
    _addAlignLine: function _addAlignLine(p) {
      var group = this.graph.get('group');
      var bbox = p.bbox;
      var lineStyle = this.alignLineStyle;
      var lineArr = this._alignLines;
      if (p.horizontals) {
        each(p.horizontals, function (lineObj) {
          var line = lineObj.line;
          var point = lineObj.point;
          var lineHalf = (line[0] + line[2]) / 2;
          var x1, x2;
          if (point.x < lineHalf) {
            x1 = point.x - bbox.width / 2;
            x2 = Math.max(line[0], line[2]);
          } else {
            x1 = point.x + bbox.width / 2;
            x2 = Math.min(line[0], line[2]);
          }
          var shape = group.addShape('line', {
            attrs: mix({
              x1: x1,
              y1: line[1],
              x2: x2,
              y2: line[1]
            }, lineStyle),
            capture: false
          });
          lineArr.push(shape);
        });
      }
      if (p.verticals) {
        each(p.verticals, function (lineObj) {
          var line = lineObj.line;
          var point = lineObj.point;
          var lineHalf = (line[1] + line[3]) / 2;
          var y1, y2;
          if (point.y < lineHalf) {
            y1 = point.y - bbox.height / 2;
            y2 = Math.max(line[1], line[3]);
          } else {
            y1 = point.y + bbox.height / 2;
            y2 = Math.min(line[1], line[3]);
          }
          var shape = group.addShape('line', {
            attrs: mix({
              x1: line[0],
              y1: y1,
              x2: line[0],
              y2: y2
            }, lineStyle),
            capture: false
          });
          lineArr.push(shape);
        });
      }
    },
    getHorizontalLines: function getHorizontalLines(bbox) {
      return [[bbox.minX, bbox.minY, bbox.maxX, bbox.minY],
      // tltr
      [bbox.minX, bbox.centerY, bbox.maxX, bbox.centerY],
      // lcrc
      [bbox.minX, bbox.maxY, bbox.maxX, bbox.maxY] // blbr
      ];
    },
    getVerticalLines: function getVerticalLines(bbox) {
      return [[bbox.minX, bbox.minY, bbox.minX, bbox.maxY],
      // tlbl
      [bbox.centerX, bbox.minY, bbox.centerX, bbox.maxY],
      // tcbc
      [bbox.maxX, bbox.minY, bbox.maxX, bbox.maxY] // trbr
      ];
    },
    getDistance: function getDistance(line, point) {
      return {
        line: line,
        point: point,
        dis: this.pointLineDistance(line[0], line[1], line[2], line[3], point.x, point.y)
      };
    },
    pointLineDistance: function pointLineDistance(lineX1, lineY1, lineX2, lineY2, pointX, pointY) {
      var lineLength = [lineX2 - lineX1, lineY2 - lineY1];
      if (vec2.exactEquals(lineLength, [0, 0])) return NaN;
      var s = [-lineLength[1], lineLength[0]];
      vec2.normalize(s, s);
      return Math.abs(vec2.dot([pointX - lineX1, pointY - lineY1], s));
    },
    _clearAlignLine: function _clearAlignLine() {
      each(this._alignLines, function (line) {
        line.remove();
      });
      this._alignLines = [];
      this.graph.paint();
    }
  });
}